import { render, staticRenderFns } from "./PostView.vue?vue&type=template&id=e8e1adf4&scoped=true&"
import script from "./PostView.vue?vue&type=script&lang=js&"
export * from "./PostView.vue?vue&type=script&lang=js&"
import style0 from "./PostView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PostView.vue?vue&type=style&index=1&id=e8e1adf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e1adf4",
  null
  
)

export default component.exports